<div>
	<div class="filter-item" [hidden] = "hidden">
		<i class="glyphicons glyphicons-globe"></i>
		<i class="glyphicons glyphicons-remove" [ngClass]="{'disabled-icon': isActionDisabled}" (click)="remove()"></i>
	</div>
</div>
